export default __webpack_public_path__ + "static/attention-672eba53dbd8be02bf6467645ed00cf9.png";